import { useRef, useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import classNames from 'classnames'
import gsap from 'gsap'
import useScrollTrigger from '@/hooks/useScrollTrigger'
import FormBoxSearch from '@/components/FormBoxSearch'
import style from './style'

const useStyles = createUseStyles(style)

const Hero = ({
  className,
  headerHeight,
  heightPercent,
  homepage,
  img,
  poster,
  locator,
  searchTerm,
  minimize,
  shrink,
  text,
  title,
  top,
  video,
  viewportHeight,
}) => {
  const classes = useStyles({ heightPercent, top, locator, headerHeight })
  const { animationReady } = useScrollTrigger()
  const $root = useRef()
  const $img = useRef()
  const $video = useRef()
  const $text = useRef()
  const $title = useRef()
  const $formWrapper = useRef()

  useEffect(() => {
    if (animationReady && $img.current) {
      gsap.to($img.current, {
        scrollTrigger: {
          trigger: $img.current,
          scrub: true,
          start: 'top 0%',
          once: false,
        },
        y: 100,
        ease: 'none',
      })
    }
    if (animationReady && $video.current) {
      gsap.to($video.current, {
        scrollTrigger: {
          trigger: $video.current,
          scrub: true,
          start: 'top 0%',
          once: false,
        },
        y: 100,
        ease: 'none',
      })
    }
  }, [animationReady])

  return (
    <div
      ref={$root}
      className={classNames({
        [classes.root]: true,
        [classes.rootViewportHeight]: viewportHeight,
        [classes.rootMinimize]: searchTerm || minimize,
        [className]: className,
      })}
    >
      {(img && !video) && (
        <img
          ref={$img}
          src={img}
          alt={title}
        />
      )}
      {video && (
        <video // eslint-disable-line
          ref={$video}
          poster={poster}
          loop
          autoPlay
          playsInline
          muted
        >
          <source src={video} type="video/mp4" />
        </video>
      )}
      <div
        className={classNames({
          [classes.wrapper]: true,
          Hero__wrapper: true,
        })}
      >
        <div
          className={classes.container}
        >
          {title && (
            <h1
              className={classes.title}
              ref={$title}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {locator && (
            <div
              ref={$formWrapper}
              className={classes.formWrapper}
            >
              <FormBoxSearch
                shrink={shrink}
                homepage={homepage}
                searchTerm={searchTerm}
              />
            </div>
          )}
          {text && (
            <p
              className={classes.text}
              ref={$text}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

Hero.defaultProps = {
  heightPercent: '43%',
  homepage: false,
  locator: false,
  shrink: false,
  top: false,
  viewportHeight: false,
}

export default Hero
